<ng-http-loader [backdrop]="true" [backgroundColor]="'#454d67'" [debounceDelay]="100"
[extraDuration]="300" [minDuration]="300" [opacity]="0.4" ></ng-http-loader>
<router-outlet></router-outlet>